import {getPageHref} from './get-page-href';

export const getEditPageHref = (slug: string, params?: Record<string, string>) =>
    getPageHref(`${slug}/.edit`, params);
